import { useDeviceLayout } from "./context/DeviceLayoutContext"

/*
    This acts as a wrapper component and based on visibility parameter
     it will decide to show that component in mobile or not
     eg: If visibility is true wrapped component will be shown on mobile and not on desktop
         If visibility is false wrapped component will be shown on desktop and not on mobile
*/
export const MobileDisplay = ( {children, visibility}) => {
    const {isMobile} = useDeviceLayout()
    
    return (
        isMobile ? (visibility ? children : null) :  
                   (visibility ? null : children)
    )
}


// WEBPACK FOOTER //
// ./src/components/common/MobileDisplay.js